import { useMemo } from 'react'
import { useCurrentUserInstitutions } from '../../api/queries/currentUser/useCurrentUserInstitutions'
import useCurrentUserInstitutionIdSelector from '../../api/selectors/useCurrentUserInstitutionIdSelector'
import { getFieldValue } from 'react-bfm'
import currentUserInstitutionIdSelector from '../../api/selectors/currentInstitutionIdSelector'
import useSetCurrentUserActiveInstitution from '../../api/queries/currentUser/useSetCurrentUserActiveInstitution'

const useInstitutionSelector = () => {
  const { data: institutions } = useCurrentUserInstitutions()
  const currentUserInstitutionId = useCurrentUserInstitutionIdSelector()
  const { mutate } = useSetCurrentUserActiveInstitution()

  const options = useMemo(() => {
    const options = institutions?.map((institution) => ({
      id: institution?.id,
      label: institution?.title,
    }))

    return options?.length ? options : []
  }, [institutions])

  const selectedInstitution = useMemo(
    () => options.find((option) => option.id === currentUserInstitutionId),
    [options, currentUserInstitutionId]
  )

  const handleInstitutionSelection = async () => {
    const institution = getFieldValue('institutionSelector', 'institution')
    const currentInstitution = currentUserInstitutionIdSelector()
    if (currentInstitution === institution.id) {
      return
    }
    await mutate(institution.id)
  }

  return {
    options,
    hasMultipleInstitutions: options.length > 1,
    selectedInstitution,
    handleInstitutionSelection,
  }
}

export default useInstitutionSelector
